exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".select-components-dialog.el-dialog__wrapper{height:100%;height:100vh}.select-components-dialog .el-dialog{margin:5vh auto!important;height:90vh;overflow:scroll}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/app/SelectComponent.vue"],"names":[],"mappings":"AACA,6CACE,YAAa,AACb,YAAc,CACf,AACD,qCACE,0BAA4B,AAC5B,YAAa,AACb,eAAiB,CAClB","file":"SelectComponent.vue","sourcesContent":["\n.select-components-dialog.el-dialog__wrapper {\n  height: 100%;\n  height: 100vh;\n}\n.select-components-dialog .el-dialog {\n  margin: 5vh auto !important;\n  height: 90vh;\n  overflow: scroll;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33b80d3b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/SelectComponent.vue
// module id = 705
// module chunks = 0 1 12